import { global } from "../../constants";

export const data = {
  banner: {
    base: "服务",
    background: global.banner + "maritime-law.webp",
    title: "商法",
    crumb: "商法",
  },
  icon: "fa-solid fa-scale-balanced",
  shortDescription:
    "为委内瑞拉公司设立和规范化提供全方位服务：从成立文件到法律、税务和行政运营。",
  title: "商法",
  features: {
    title: "商法",
    deliverables: "交付物",
    reqDocuments: "所需文件",
    subtitle: "委内瑞拉公司设立及一揽子商事服务，助力企业合规运营。",
    description: `公司设立与商事规范化全程服务：起草成立文件、制作授权书、办理注册和公告、组织资产清单及开业资产负债表、开设银行账户、办理RIF及在INCES、IVSS等机构登记。此外，提供企业运营所需的商事合同起草与分析服务。`,
    viewDetail: "查看详情",
    feats: [
      {
        key: "constitucion",
        title: "成立文件起草及注册",
        summary: "个性化起草公司章程/规章，全面办理商事注册直至正式登记。",
        details:
          "根据推荐公司类型（C.A.、S.R.L.等）、股权结构、注册资本及管理规则设计成立文件。包括章程、社会条款、固有授权书起草，并提交至主管商事注册处直至登记完成。",
        deliverables: [
          "成立文件草稿（Word/PDF）",
          "公证文件及签字（如适用）",
          "注册登记证明",
        ],
        requiredDocs: [
          "股东/合伙人信息（身份证、RIF如适用）",
          "公司类型及资本金额决定",
          "授权书或批文（如适用）",
        ],
        icon: "fa-solid fa-file-signature",
        image: global.services + "commercial_law/1.webp",
      },
      {
        key: "poderes",
        title: "公证及公司授权书起草",
        summary: "为法定代表人、受托人及行政管理者起草并办理授权书。",
        details:
          "根据运营需求（银行开户、税务管理、注册手续）定制有限或一般授权书。提供范围、期限及可撤销性建议，协调签署及公证。",
        deliverables: [
          "授权书草稿（Word/PDF）",
          "公证格式模板",
          "提交及有效性清单",
        ],
        requiredDocs: [
          "受托人及授权人身份证明",
          "授权内容（范围与限制）",
          "公司支持文件",
        ],
        icon: "fa-solid fa-pen-fancy",
        image: global.services + "commercial_law/2.webp",
      },
      {
        key: "traduccion",
        title: "法律翻译及文件认证",
        summary: "为委内瑞拉或境外使用提供章程、授权书及公证文件的认证翻译。",
        details:
          "协调宣誓翻译及认证或加签（如适用），确保法律等效及行政合规。适用于外籍投资者及原文为其他语言的文件。",
        deliverables: [
          "文件宣誓翻译",
          "认证/加签指南",
          "可用于注册/交付的文件",
        ],
        requiredDocs: ["需翻译原件", "所需语言及格式说明", "申请人身份证明"],
        icon: "fa-solid fa-language",
        image: global.services + "commercial_law/3.webp",
      },
      {
        key: "estatus_migratorio",
        title: "外籍股东/代表移民身份调整",
        summary: "为非居民股东或代表提供移民身份规范化咨询与协调。",
        details:
          "协助办理许可、签证及所需文件，使外籍股东或受托人可履行公司职能并满足行政要求。根据情况协调移民事务所及主管机构。",
        deliverables: [
          "按案例列明移民要求",
          "与移民专家办理或协调",
          "模板及支持文件",
        ],
        requiredDocs: [
          "外籍人员护照及个人文件",
          "证明关系的公司文件",
          "授权书及批文",
        ],
        icon: "fa-solid fa-passport",
        image: global.services + "commercial_law/4.webp",
      },
      {
        key: "comisario",
        title: "监事委任及咨询",
        summary: "协助委任商事监事及其控制与审计职责履行。",
        details:
          "就监事角色（要求、职能及责任）提供建议，推荐候选人或协助聘用，并准备正式委托。促进监事与董事会及公司会计的关系。",
        deliverables: ["监事合同/委托模板", "职能与义务指南", "委任及登记决议"],
        requiredDocs: ["拟任监事信息", "公司章程及授权书", "基础会计文件"],
        icon: "fa-solid fa-user-tie",
        image: global.services + "commercial_law/5.webp",
      },
      {
        key: "libros",
        title: "公司账簿管理及加盖",
        summary: "办理会计及会议账簿的认证与加盖，确保运营与合规。",
        details:
          "准备并认证会议账簿、资产清单、会计及其他必需记录；协调商事注册处及公证处加盖与登记。",
        deliverables: ["待认证账簿", "加盖/登记证明", "使用与保管说明"],
        requiredDocs: [
          "章程及前期会议记录",
          "管理者身份证明",
          "授权书（如适用）",
        ],
        icon: "fa-solid fa-book",
        image: global.services + "commercial_law/6.webp",
      },
      {
        key: "publicaciones",
        title: "官方公告及法律通知",
        summary:
          "根据法律要求办理报刊及公报公告，适用于公司设立、变更及商事行为。",
        details:
          "起草并协调报纸或官方公报强制公告，监督法定期限并获取公告证明以归档。",
        deliverables: [
          "已发布公告/公报",
          "公告证明及证书",
          "标准化通知及召集文本",
        ],
        requiredDocs: [
          "公司批准文本",
          "公告所需信息（日期、印数）",
          "需公告公司文件",
        ],
        icon: "fa-solid fa-newspaper",
        image: global.services + "commercial_law/7.webp",
      },
      {
        key: "inventario_balance",
        title: "资产清单及开业资产负债表",
        summary: "编制公司开业所需的初始资产清单及资产负债表。",
        details:
          "整理出资资产及负债清单，评估初始价值并按适用会计准则编制开业资产负债表，附说明及支持文件。",
        deliverables: [
          "详细资产清单",
          "签署的开业资产负债表（可用于会计）",
          "说明及支持文件",
        ],
        requiredDocs: [
          "出资清单（资产、现金、证券）",
          "发票或产权证书",
          "估值文件（如适用）",
        ],
        icon: "fa-solid fa-clipboard-list",
        image: global.services + "commercial_law/8.webp",
      },
      {
        key: "apertura_bancaria",
        title: "企业银行账户开设",
        summary: "协助办理委内瑞拉金融机构企业账户开户及相关要求。",
        details:
          "准备所需银行材料，陪同提交至金融机构，并就授权签字人、操作限额及KYC/AML合规要求提供咨询。",
        deliverables: [
          "各银行开户要求清单",
          "预组装材料（交付银行）",
          "预约及验证支持",
        ],
        requiredDocs: [
          "成立文件及注册证明",
          "公司RIF",
          "签字人授权书及身份证明",
        ],
        icon: "fa-solid fa-university",
        image: global.services + "commercial_law/9.webp",
      },
      {
        key: "rif",
        title: "税务信息登记（RIF）办理",
        summary: "为公司向委内瑞拉税务机关（SENIAT）办理RIF登记及获取。",
        details:
          "办理公司税务登记，向税务机关提交所需文件并获取RIF编号，以启动税务义务及开具发票。",
        deliverables: ["向SENIAT提交申请", "RIF证明/凭证", "初始税务义务指南"],
        requiredDocs: [
          "成立文件及注册证明",
          "代表身份证/RIF",
          "税务地址及联系方式",
        ],
        icon: "fa-solid fa-id-card",
        image: global.services + "commercial_law/10.webp",
      },
      {
        key: "inscripciones",
        title: "INCES、IVSS及公共机构登记",
        summary: "办理INCES、IVSS等劳动及社保机构的登记与入会。",
        details:
          "准备并提交所需材料至相关公共机构（INCES、IVSS、市政、劳动登记处），并指导定期义务及表格填写。",
        deliverables: [
          "已提交材料及凭证",
          "定期义务合规指南",
          "雇主及入会登记",
        ],
        requiredDocs: [
          "公司RIF",
          "成立文件及代表身份证明",
          "初始劳动信息（预计工资表）",
        ],
        icon: "fa-solid fa-clipboard-check",
        image: global.services + "commercial_law/11.webp",
      },
      {
        key: "contratos",
        title: "商事合同起草与分析",
        summary: "编制及审查商事合同：服务、分销、代理、供应及其他商事协议。",
        details:
          "根据公司业务起草商事合同，审查责任条款、付款条件、违约条款、担保、保密及争议解决；提供谈判及执行机制建议。",
        deliverables: [
          "合同草稿及最终版本",
          "合同风险分析及建议",
          "可选条款及模板（保密协议、服务协议、担保等）",
        ],
        requiredDocs: [
          "商业背景及谈判条款",
          "各方及税务信息",
          "相关技术或商业文件",
        ],
        icon: "fa-solid fa-file-contract",
        image: global.services + "commercial_law/12.webp",
      },
    ],
  },
  ctaText: "申请商事咨询",
  ctaLink: "/contact?service=commercial-law",
};
